<template>
<div class="viewAgreement">  
   <Header title="查看协议"></Header>
     <div class="main-viewAgreement">
      <viewAgreement class="viewAgreement" ref="Agreement"></viewAgreement>
     </div>
    
</div>
</template>

<script>
import viewAgreement from "@/components/viewAgreementC";
import Header from "@/components/Header";
import orderApi from "@/request/orderApi";
export default {
  name: "ViewAgreement",
  components: {
    viewAgreement,
    Header
  },
  data() {
    return {
      agreementSignList: []
    };
  },
  created() {
    this.viewAgreement();
  },
  methods: {
    // 协议
    viewAgreement() {
       let params = {
        id: this.$route.query.id,
      };
      orderApi.orderDetail(params).then((res) => {
        if (res.returnCode == "0") {
          this.agreementSignList = res.result.agreementSignList;
          this.$refs.Agreement.viewAgreement(this.agreementSignList[0].agreementType, this.agreementSignList[0].templateId);
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
      console.log("agreementSignList", this.agreementSignList)

    },
    
  }
};
</script>

<style lang="stylus" scoped>
.viewAgreement {
  display: flex;
  flex-direction: column;
  height: 100%;
  .main-viewAgreement {
    flex: 1;
    height: calc(100% - 88px);
    position: absolute;
    // padding: 0 20px;
    top: 0.88rem;
    left: 0;
    right: 0;
    font-size: 28px;
    overflow: auto;
  }
}
</style>